import { HttpContext } from '@angular/common/http';
import { Component, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
import { UserService } from '../../../swagger';
import { DISABLE_UNAUTHINTERCEPTOR } from '../../../utils/unauthorized.interceptor';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  readonly form = new FormGroup({
    username: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.email] })
  });

  readonly submitting = signal(false);
  readonly error = signal(false);
  readonly success = signal(false);

  readonly #context = new HttpContext().set(DISABLE_UNAUTHINTERCEPTOR, true);

  constructor(private readonly userService: UserService, route: ActivatedRoute) {
    route.params.subscribe(params => {
      if (params['user']) {
        this.form.controls.username.setValue(decodeURIComponent(params['user']));
      }
    });
  }

  submit() {
    if (this.submitting()) return;

    this.error.set(false);
    this.success.set(false);
    this.form.markAllAsTouched();

    const username = this.form.controls.username.value.trim();
    this.form.controls.username.setValue(username);

    if (this.form.invalid) return;

    this.submitting.set(true);

    this.userService
      .userGeneratePasswordResetTokenPost(username, 'body', false, { context: this.#context })
      .pipe(finalize(() => this.submitting.set(false)))
      .subscribe({
        next: () => {
          this.success.set(true);
        },
        error: () => {
          this.error.set(true);
        }
      });
  }
}
